import { render, staticRenderFns } from "./categories-list.vue?vue&type=template&id=0f4d110c&scoped=true&"
import script from "./categories-list.vue?vue&type=script&lang=js&"
export * from "./categories-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4d110c",
  null
  
)

export default component.exports